import axios from 'axios';

export default class HeaderCheckout {
    mainSelector = 'main';
    infoSelector = '[data-js-publication-info]';
    orderSelector = '[data-js-add-to-cart]';
    modalSelector = '[data-js-modal-checkout]';
    modalPriceSelector = '.floating-shopping-cart__inner__content__price';
    modalTitleSelector = '.floating-shopping-cart__inner__content__title';
    modalImageSelector = '.floating-shopping-cart__inner__content__img > img';
    modalPackagingInformationSelector = '.floating-shopping-cart__inner__content__packaging-info'; 
    modalVisibleClass = 'floating-shopping-cart--visible';
    modalCloseButtonSelector = '.floating-shopping-cart__inner__top__close__button';
    modalContiueShoppingSelector = '.floating-shopping-cart__button__container__continue-shopping';
    maskClass = 'js-mask';

    productHandlerEndpoint = '/api/shoppingcartapi';

    firstFocusableElement = null;
    lastFocusableElement = null;

    constructor() {    
        this.setupComponent();   
    }

    setupComponent() {
        this.updateShoppingCart();
        const elements = getElementList(document, this.infoSelector);

        elements.forEach(element => {
            this.setupEvents(element);
        });
    }

    setupEvents(element) {
        const orderButton = element.querySelector(this.orderSelector);
        const modal = document.querySelector(this.modalSelector);
        const main = document.querySelector(this.mainSelector);

        if (orderButton) {
            const href = orderButton.getAttribute('href');
            const id = href.substring(href.indexOf('?') + 4);
        
            orderButton.addEventListener('click', (event) => {
                event.stopPropagation();
                event.preventDefault();
                this.addToCart(id)
                    .then( ({title, price, count, source, alt, packagingInformation}) => {
                        this.openModal(modal, main);
                        this.addData(title, price, source, alt, packagingInformation);
                        updateCounter(count);
                    })
                    .catch(error => {
                        console.log(error)
                    });
            })
        }
    }

    addToCart(id) {
        return axios.get(this.productHandlerEndpoint, {
            params: {
                id: id,
                output: 'json'
            }
        })
            .then(response => {
                const title = response.data.item.name;
                const price = response.data.item.pricePerUnit;
                const count = response.data.totalCount;
                const source = response.data.item.imageUrl;
                const alt = response.data.item.imageAlt;
                const packagingInformation = response.data.item.packagingInformation;

                return {title, price, count, source, alt, packagingInformation};
            })
    }

    updateShoppingCart() {
        axios.get(this.productHandlerEndpoint, {
            params: {
                cmd: 'dsp',
                output: 'json'
            }
        }).then(response => {
            const count = response.data.totalCount;

            if (count > 0) {
                updateCounter(count);
            }
        });
    }

    openModal(modal, main) {
        modal.classList.add(this.modalVisibleClass);
        main.classList.add(this.maskClass);

        //fix body to prevent scroll
        document.body.style.position = 'fixed';
        document.body.style.top = `-${window.scrollY}px`;
        modal.setAttribute('aria-hidden', false)

        modal.focus();
        this.enableTrapFocus(modal);

        window.addEventListener('click', this.clickedCloseModal.bind(this));
    }

    clickedCloseModal(event) {
        const modal = document.querySelector(this.modalSelector);
        const main = document.querySelector(this.mainSelector);

        const clickInsideModal = event.target.closest(this.modalSelector);
        const clickOnCloseButton = event.target.matches(this.modalCloseButtonSelector);
        const clickOnContinueShoppingButton = event.target.matches(this.modalContiueShoppingSelector);

        if (!clickInsideModal || clickOnCloseButton || clickOnContinueShoppingButton ){
            this.closeModal(modal, main);
        }
    }

    enableTrapFocus(modal) {
        const focusableElements = 'button, [href]';
        const focusableContent = modal.querySelectorAll(focusableElements);

        this.firstFocusableElement = focusableContent[0];
        this.lastFocusableElement = focusableContent[focusableContent.length - 1];
    
        document.addEventListener('keydown', this.keyDownListener.bind(this));
    }

    keyDownListener(e) {
        let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

        if (!isTabPressed) {
          return;
        }

        if (e.shiftKey) { // if shift key pressed for shift + tab combination
            if (document.activeElement === this.firstFocusableElement) {
                this.lastFocusableElement.focus(); // add focus for the last focusable element
                e.preventDefault();
            }
            } else { // if tab key is pressed
                if (document.activeElement === this.lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
                this.firstFocusableElement.focus(); // add focus for the first focusable element
                e.preventDefault();
            }
        }
    }

    closeModal(modal, main) {
        modal.classList.remove(this.modalVisibleClass);
        main.classList.remove(this.maskClass);
        modal.setAttribute('aria-hidden', true);
        //allow scroll on body
        document.body.style.position = '';
        document.body.style.top = '';
        document.removeEventListener('keydown', this.keyDownListener);
        window.removeEventListener('click', this.clickedCloseModal);
    }

    addData(title, price, source, alt, packagingInformation) {
        let modalTitle = document.querySelector(this.modalTitleSelector);
        let modalPrice = document.querySelector(this.modalPriceSelector);
        let modalImgSrc = document.querySelector(this.modalImageSelector);
        let modalPackagingInformation = document.querySelector(this.modalPackagingInformationSelector);

        if (title) {
            modalTitle.innerHTML = title;
        }
        if (price) {
            modalPrice.innerHTML = price;
        }
        if (source) {
            modalImgSrc.src = source;
        }
        if (alt) {
            modalImgSrc.setAttribute("alt", alt);
        }
        if (packagingInformation) {
            modalPackagingInformation.innerHTML = packagingInformation;
        }
    }
}


function getElementList(parent, query) {
    const elements = parent.querySelectorAll(query);
    return Array.from(elements);
}

export function updateCounter(amount) {
    const cartSelector = '[data-js-header-checkout]';
    const checkOutCart = document.querySelector(cartSelector);
    const cartVisibleClass = 'shopping-cart__expand-button--visible';
    const amountSelector = '[data-js-total-amount]';
    const totalAmount = document.querySelector(amountSelector);
    totalAmount.innerHTML = amount;

    if (amount === 0) {
        checkOutCart.removeAttribute('aria-expanded');
        checkOutCart.classList.remove(cartVisibleClass);
    } else {
        checkOutCart.setAttribute('aria-expanded', 'true');
        checkOutCart.classList.add(cartVisibleClass);
    }
}